import { atom } from "recoil";
import { Team } from "../model";

export const teamState = atom<Team | undefined>({
  key: 'teamState',
  default: undefined,
});